import styles from './AvailabilityStatusInfo.module.scss'
import { Alert } from 'react-bootstrap'
import availabilityStatusTenantSettingsObject from '@/entities/availabilityStatusTenantSettings/interface'

interface Props {
  availabilityStatusTenantSettings: availabilityStatusTenantSettingsObject
}

const AvailabilityStatusInfo = ({ availabilityStatusTenantSettings: tenantSettings }: Props) => {
  if (!tenantSettings.info) {
    return <></>
  }

  return (
    <Alert className={styles.infoAlert} variant={'warning'}>
      {tenantSettings.info}
    </Alert>
  )
}

export default AvailabilityStatusInfo
